import Vue from "vue";
import App from "./App.vue";
import VueCryptojs from "vue-cryptojs";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import dashboard from "./packages/dashboard";
import profile from "./packages/profile";
import Renewal from "./packages/renewals";
import appAlert from "@/packages/dashboard/plugins/appAlert";
import VueSanitize from "vue-sanitize";
// import subscription from "./packages/subscription";
import Applications from "./packages/applications";
import checkList from "./packages/checklist";
import billing from "./packages/billing";
// import listener from "@brainspore/celadon-base/mixin/listeners/listener";
import { filters } from "@/packages/dashboard/utils";
import ConfirmationComponent from "./packages/dashboard/plugins/confirmtion";
import verify from "./packages/dashboard/plugins/verify";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueTelInputVuetify from "vue-tel-input-vuetify/lib";
import exams from "@/packages/exams";
import Setting from "@/packages/Setting";
import Administrator from "@/packages/administrator";
import Exemptions from "@/packages/exemptions";
import Refund from "@/packages/refund";
import Reinstatement from "@/packages/Reinstatement";
import { setupTimers } from "@/packages/dashboard/utils/auto-logout";
import listener from "@/packages/dashboard/mixin/listeners/listener";
import VueEllipseProgress from "vue-ellipse-progress";
import { navigationType } from "@/packages/dashboard/utils/check-page-reload";

import paygate from "@kinetics254/paygate";

Vue.use(VueEllipseProgress);

Vue.config.productionTip = false;

window.Event = new Vue();

const options = {
  store,
  router,
};

Vue.use(VueTelInputVuetify, {
  vuetify,
});
Vue.use(VueCryptojs);
Vue.use(VueSanitize);
Vue.use(Toast);
Vue.use(ConfirmationComponent);
Vue.use(appAlert);
Vue.use(verify, options);
Vue.use(checkList, options);
Vue.use(dashboard, options);
Vue.use(billing, options);
Vue.use(Applications, options);
Vue.use(Exemptions, options);
Vue.use(Renewal, options);
Vue.use(exams, options);
Vue.use(profile, options);
Vue.use(Setting, options);
Vue.use(Refund, options);
Vue.use(Reinstatement, options);
Vue.use(Administrator, options);
Vue.use(setupTimers);
Vue.use(navigationType);

Vue.use(paygate.paygateCheckout, { store });
Vue.use(paygate.appCheckoutAlert);

filters.forEach((f) => {
  Vue.filter(f.name, f.execute);
});
Vue.use(VueEllipseProgress);
new Vue({
  router,
  store,
  vuetify,
  mixins: [listener],
  render: (h) => h(App),
}).$mount("#app");
